import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import mattress from '../../json/mattress-removal-data.json'

const mattressServiceData = {
  name: 'Mattress Removal and Recycling',
  description:
    'Easy, cheap mattress disposal and recycling for homes and businesses nationwide. Dimension removes mattresses, box springs, and bed frames, recovering steel, foam, and fiber for recycling.',
  serviceType: 'Mattress Removal',
  url: 'https://getdimension.com/mattress-removal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Mattress Recycling' },
    { name: 'Box Spring Removal' },
    { name: 'Bed Frame and Headboard Removal' },
    { name: 'Hotel and Property Mattress Disposal' },
  ],
}

const mattressFAQData = {
  questions: mattress.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function MattressRemoval() {
  return (
    <>
      <Head>
        <title>Mattress Removal &amp; Recycling Services | Dimension</title>
        <meta
          name="description"
          content="Easy, cheap mattress disposal and recycling nationwide. Dimension removes mattresses, box springs, and bed frames from anywhere in your home, recycling steel, foam, and fiber. From around $79."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/mattress-removal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={mattressServiceData} />
        <SchemaMarkup type="FAQPage" data={mattressFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={mattress.pitch.heading}
          material={mattress.pitch.material}
          pitchText={mattress.pitch.pitchText}
          ctaLink={mattress.pitch.ctaLink}
          ctaText={mattress.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...mattress.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...mattress.benefits} />
        <Approach {...mattress.approach} />
        <FAQ {...mattress.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Furniture Removal',
              href: '/furniture-removal',
              description:
                'Convenient removal of sofas, chairs, desks, and bulky furniture, with donation and recycling first.',
            },
            {
              label: 'Appliance Removal',
              href: '/appliance-removal',
              description:
                'Pickup and metal recycling of refrigerators, washers, ovens, and other appliances.',
            },
            {
              label: 'Junk Removal',
              href: '/junk-removal',
              description:
                'Full-service junk hauling and whole-home or office cleanouts, priced by volume.',
            },
            {
              label: 'Yard Debris Removal',
              href: '/yard-debris-removal',
              description:
                'Eco-friendly removal of branches, brush, and yard waste, priced by the cubic yard.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default MattressRemoval
